import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import { useState } from 'react';
import CreateVendorReceipt from './shared/CreateVendorReceipt';
import VendorReceiptTable from './shared/VendorReceiptTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const VendorReceipt = () => {
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CreateVendorReceipt handleApiCall={handleApiCall} />
            <VendorReceiptTable apiCall={apiCall} handleApiCall={handleApiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default VendorReceipt;
